angular.module('wbDashboard').controller('FundingRolloversCreateControllerAurea',
        ['$scope', '$uibModal', '$q', '$filter', 'User', 'Message', 'PlanService',
function ($scope, $uibModal, $q, $filter, User, Message, PlanService) {

    $scope.pageData.percent = 0;
    $scope.pages = ['account-source', 'account-destination', 'simple-age', 'account-broker',
                    'account-value', 'account-fees', 'tax-protection', 'confirm'];
    $scope.rollover = {};

    $scope.options = {
        accountSources: [
            {
                code: "roth-ira", description: "Roth IRA", type: "Transfer",
                note: "Great! You can transfer into a Managed Portfolios Roth IRA."
            },
            {
                code: "traditional-ira", description: "Traditional IRA", type: "Transfer",
                note: "Easy! You can transfer into a Managed Portfolios Traditional IRA."
            },
            {
                code: "sep-ira", description: "SEP IRA", type: "Transfer",
                note: "You'll choose the type of account for this to transfer into on the next step."
            },
            {
                code: "simple-ira", description: "Simple IRA", type: "Transfer",
                note: "You can transfer into a Managed Portfolios Traditional IRA."
            },
            {
                code: "traditional-401k", description: "401(k)", type: "Rollover",
                note: "You can roll this into a Managed Portfolios Traditional IRA for similar tax benefits."
            },
            {
                code: "roth-401k", description: "Roth 401(k)", type: "Rollover",
                note: "Great! You can rollover into a Managed Portfolios Roth IRA."
            },
            {
                code: "403b", description: "403(b)", type: "Rollover",
                note: "You can roll this into a Managed Portfolios Traditional IRA for similar tax benefits."
            },
            {
                code: "pension", description: "Pension", type: "Rollover",
                note: "You can roll this into a Managed Portfolios Traditional IRA for similar tax benefits."
            },
            {
                code: "457b", description: "457(b)", type: "Rollover",
                note: "You can roll this into a Managed Portfolios Traditional IRA for similar tax benefits."
            },
            {
                code: "thrift-savings-plan", description: "Thrift Savings Plan", type: "Rollover",
                note: "You can roll this into a Managed Portfolios Traditional IRA for similar tax benefits."
            }
        ],
        accountSepDestinations: [
            // {code: "roth-ira", description: "Roth IRA", type: "Rollover"},
            {code: "sep-ira", description: "SEP IRA", type: "Rollover"},
            {code: "traditional-ira", description: "Traditional IRA", type: "Rollover"},
        ]
    };

    if ($scope.$stateParams.page !== 'account-source') {
        $scope.$state.go(".",{page:'account-source'});
    }

    $scope.prepareData = function() {
        var data = angular.copy($scope.rollover);

        delete data.sep_age;
        delete data.savings;
        if (data.source_account_type) {
            data.source_account_type = data.source_account_type.code;
        }
        if (data.source_account_type === 'sep-ira' && data.target_account_type) {
            data.target_account_type = data.target_account_type.code;
        } else {
            delete data.target_account_type;
        }
        return data;
    };
    $scope.submit = function() {
        $scope.pageData.sending = true;
        PlanService.user.nextRolloverStep($scope.rollover.rollover_id).then(function(response) {
            return PlanService.user.retrieveRollovers(true);
        }).then(function(rollovers) {
            $scope.rollovers = rollovers;
            $scope.$state.go("base.funding.rollovers.pending");
        }).catch(function() {
            Message.set({
                type: 'danger',
                text: 'There was an error starting your rollover, please try again later.',
            });
        }).finally(function() {
            $scope.pageData.sending = false;
        });
    };
    $scope.saveRollover = function() {
        var data = $scope.prepareData();

        PlanService.user.saveRollover(data).then(function(rollover) {
            $scope.rolloverSaved = rollover;
            $scope.rollover.rollover_id = rollover.uuid;
        });
    };
    // $scope.$watch('rollover', function(rollover, old) {
    //     if (rollover.rollover_id !== old.rollover_id) { return; }
    //
    //     if (rollover && Object.keys(rollover).length) {
    //         $scope.saveRollover();
    //     }
    // }, true);
    $scope.$watch('rollover.fee', function(fee) {
        if (true || fee || fee === 0) {
            $scope.updateForecast(fee);
        }

    }, true);
    $scope.updateForecast = function(fee) {
        if (!$scope.rollover.amount) return;
        var data = {
            rollover_id: $scope.rollover.rollover_id,
            rollover_value: $scope.rollover.amount,
            fee: fee
        };
        $scope.pageData.gettingForecast = true;
        PlanService.user.getRolloverForecast(data).then(function (savings) {
            savings.source_ratio_to_wb = savings.source_account_value.value_at_retirement/savings.wisebanyan_account_value.value_at_retirement;
            savings.difference_at_retirement = savings.wisebanyan_account_value.value_at_retirement - savings.source_account_value.value_at_retirement;
            $scope.rollover.savings = savings;
        }).finally(function() {
            $scope.pageData.gettingForecast = false;
        });
    };

    $scope.goNextPage = function() {
        var pageIndex = $scope.pages.indexOf($scope.$stateParams.page);
        var nextPage = null;
        // after current page
        switch ($scope.$stateParams.page) {
            case 'account-source':
                if ($scope.rollover.source_account_type.code !== 'sep-ira') {
                    delete $scope.rollover.target_account_type;
                }
                if ($scope.rollover.source_account_type.code === 'sep-ira') {
                    nextPage = 'account-destination';
                } else if ($scope.rollover.source_account_type.code === 'simple-ira') {
                    nextPage = 'simple-age';
                } else {
                    nextPage = 'account-broker';
                }
                break;
            case 'account-value':
                $scope.updateForecast(null);
                break;
            case 'account-fees':
                break;
            case 'account-destination':
            case 'simple-age':
                nextPage = 'account-broker';
                break;
            default:
                break;
        }
        if (!nextPage) {
            nextPage = $scope.pages[pageIndex+1];
        }
        nextPage = $scope.beforePage(nextPage);

        if ($scope.$stateParams.page === 'confirm') {
            $scope.submit();
        } else {
            $scope.goToPage(nextPage);
        }

    };
    /**
     * Actions preformed to initialize page, or change page
     * @param page
     * @returns {*}
     */
    $scope.beforePage = function(page) {
        var nextPage = page;
        var pageIndex = $scope.pages.indexOf(page);

        switch (nextPage) {
            case '':
                break;
        }
        if (nextPage !== page) {
            nextPage = $scope.beforePage(nextPage);
        }
        return nextPage;
    };
    $scope.goToPage = function(page) {
        $scope.$state.go(".",{page:page});
    };

    var oldRollover = {};
    var transitionDeregisterHook = $scope.$transitions.onSuccess({ to: "base.funding.rollovers.**" }, function() {
        $scope.pageData.percent = ($scope.pages.indexOf($scope.$stateParams.page)+1)/$scope.pages.length * 100;
        if ($scope.rollover && Object.keys($scope.rollover).length && !angular.equals(oldRollover, $scope.rollover)) {
            //only updated when changed on page switch
            $scope.saveRollover();
            oldRollover = angular.copy($scope.rollover);
        }
    });
    $scope.$on('$destroy', function() {
        if (transitionDeregisterHook) {
            transitionDeregisterHook();
        }
    });

}]);
